import React from 'react'
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
/* logo */
import logo from '../../../assets/logo.png'
import "./-logo_styles.scss"
import { useNavigate } from 'react-router-dom';

const LogoHeader = (props: any) => {
    const history = useNavigate()
    const exitApp = () => {
        localStorage.clear()
        history('/')
    }
    return (
        <header className="d-flex col-lg-4 col-md-4 col-sm-12 flex-row justify-content-center">
            { props.logoff ? <div className="icon-logout" onClick={() => exitApp()}>
                <ExitToAppIcon />
            </div> : null }
            <img src={logo} width={props.width} height={props.height} alt="Economia Inteligente"/>
        </header>
    )
}
export default LogoHeader